import axios from 'axios'

const movimenti = {
    state: {
        component: 'Index',
        posix: new Date().toISOString().substr(0, 10),
        edit: false,
        all: [],
    },

    mutations: {
        CHANGE_MOVIMENTI_COMPONENT(state, payload) {
            state.component = payload
        },
        CHANGE_MOVIMENTI_EDIT(state, payload) {
            state.edit = payload
        },
    },

    actions: {
        insert_new_movement: async (_, payload) => {

            const config = {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                }
            }

            try {
                const {
                    data
                } = await axios.post(`${process.env.VUE_APP_API}/movements/insert`, payload, config)

                console.info(data)
                return {
                    status: 200,
                    data: data
                }
            } catch (error) {

                console.error(error)
                return {
                    status: 500,
                    error: error
                }
            }
        },

        update_movement: async (_, payload) => {

            const config = {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                }
            }

            try {
                const {
                    data
                } = await axios.post(`${process.env.VUE_APP_API}/movements/update`, payload, config)

                console.info(data)
                return {
                    status: 200,
                    data: data
                }
            } catch (error) {

                console.error(error)
                return {
                    status: 500,
                    error: error
                }
            }
        },

        delete_movement: async (_, payload) => {

            const config = {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                }
            }

            try {
                const {
                    data
                } = await axios.post(`${process.env.VUE_APP_API}/movements/delete`, payload, config)

                console.info(data)
                return {
                    status: 200,
                    data: data
                }
            } catch (error) {

                console.error(error)
                return {
                    status: 500,
                    error: error
                }
            }
        }
    },

    getters: {
        getMovimentiComponent: state => state.component,
        getMovimentiEdit: state => state.edit
    }
}


export default movimenti